import { Enumeration } from '../../../utils/AppEnum';

export class PortOpeningRequestsDirection extends Enumeration<PortOpeningRequestsDirection> {

    // eslint-disable-next-line react/static-property-placement
    public displayName: string;

    constructor(name?: string, value?: number, displayName?: string) {
    	super(name, value);
    	this.displayName = displayName;
    }

    public static SubscriptionToInternet = new PortOpeningRequestsDirection('SubscriptionToInternet', 0, 'Subscription -> Internet');

    public static SubscriptionToOnPrem = new PortOpeningRequestsDirection('SubscriptionToOnPrem', 1, 'Subscription <-> ExxonMobil Network');
    
    public static AccountToInternet = new PortOpeningRequestsDirection('AccountToInternet', 2, 'Account -> Internet');

    public static L4ToInternet = new PortOpeningRequestsDirection('L4ToInternet', 3, 'L4 -> Internet Direct Outbound');

    public static iBossProxyToInternet = new PortOpeningRequestsDirection('iBossProxyToInternet', 4, 'iBoss/Proxy -> Internet');

    public static InternetToNorthFirewall = new PortOpeningRequestsDirection('InternetToNorthFirewall', 5, 'Internet <-> DMZ "North" Firewall');

    public static InternetToSouthFirewall = new PortOpeningRequestsDirection('InternetToSouthFirewall', 6, 'L4 <-> DMZ "South" Firewall');

    public static L4ToL3LablanXTO = new PortOpeningRequestsDirection('L4ToL3LablanXTO', 7, 'L4 <-> L3, Lablan, XTO');

    public static OnPremToInternet = new PortOpeningRequestsDirection('OnPremToInternet', 8, 'OnPrem -> Internet');

    public static NECTUpdate = new PortOpeningRequestsDirection('NECTUpdate', 9, 'NECT Update');

    public static NewRequest = new PortOpeningRequestsDirection('NewRequest', 10, 'New Request');

    public static TrustedToInternet = new PortOpeningRequestsDirection('TrustedToInternet', 11, 'Trusted -> Internet');

    public static InternetToDMZNorth = new PortOpeningRequestsDirection('InternetToDMZNorth', 12, 'Internet -> DMZ (North)');
    
    public static DMZTrustedToL4South = new PortOpeningRequestsDirection('DMZToTrustedL4', 13, 'DMZ -> Trusted/L4 (South)');

    public static DMZToInternetSouthObi = new PortOpeningRequestsDirection('DMZToInternetSouth', 14, 'DMZ --> Internet (South + obi)');

    public static GLLOnPremToGLLAWS = new PortOpeningRequestsDirection('GLLOnPremToGLLAWS', 15, 'GLL on-prem <-> GLL AWS');

    public static GLLAWSToGLLAWS = new PortOpeningRequestsDirection('GLLAWSToGLLAWS', 16, 'GLL AWS <-> GLL AWS');

    public static GLLAWSToGLUizL4 = new PortOpeningRequestsDirection('GLLAWSToGLLUIZL4', 17, 'GLL AWS <-> GLL UIZ L4');

    public static UntrustedToL4 = new PortOpeningRequestsDirection('UntrustedToL4', 18, 'Untrusted <-> L4');

    public static UntrustedToInternet = new PortOpeningRequestsDirection('UntrustedToInternet', 19, 'Untrusted -> Internet');

    public static ExternalAccounts = new PortOpeningRequestsDirection('ExternalAccounts', 20, 'ExternalAccounts');
}